import React, { useEffect, useState } from 'react'
import RightPanel from 'components/RightPanel/RightPanel'
import { useParams, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import AdminPanelCN from 'components/AdminPanelCN/AdminPanelCN'
import HeaderCN from 'components/HeaderCN/HeaderCN'
import SecondaryNavCN from 'components/SecondaryNavCN/SecondaryNavCN'
import { AssetReportsButton } from 'features/Explorer/components/AssetReportsButton'
import SidebarLocationProjectRecent from 'components/Sidebars/SidebarLocationProjectRecent'
import SidebarLocationProjectPartners from '../../components/Sidebars/SidebarLocationProjectPartners'
import { Avatar, AvatarImage, AvatarFallback } from 'components/ui/avatar'
import Popup from 'components/Popup'
import MapLocationPopupCN from 'components/popups/MapLocationPopupCN'
import LocationActionSheet from './components/Locations/LocationActionSheet'
import { prepareLocationForSave } from './utils/prepareLocationForSave'
import RenderSubRoutes from 'components/RenderSubRoutes'
import getLocationProjectPartnerRoutes from './getRoutes/getLocationProjectPartnerRoutes'
import getLocationProjectRoutes from './getRoutes/getLocationProjectRoutes'
import getCenterProjectRoutes from './getRoutes/getCenterProjectRoutes'
import { BusinessCard } from 'components/Card'
import routes from 'constants/routes'
import useMediaQuery from 'hooks/useMediaQuery'
import * as _ from 'styles/helpers'
import { initializeApiKey } from 'slices/apiKeysSlice'
import { getLocationByID, initializeActiveLocations, initializeLocations, updateLocation } from 'slices/locationSlice'
import { initializeUsers } from 'slices/usersSlice'
import { initializeProjects } from 'slices/projectSlice'

const Locations_Projects_ShowCN = () => {
	const dispatch = useDispatch()
	const params = useParams()
	const { id, projectId } = params
	const locationId = id

	const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
	const [backTitle, setBackTitle] = useState(null)
	const [backLink, setBackLink] = useState(null)
	const [openEditPopup, setOpenEditPopup] = useState(false)
	const [openMap, setOpenMap] = useState(false)
	const [recordForEdit, setRecordForEdit] = useState<any>(null)
	const [center, setCenter] = useState<number[]>([])
	const [mapTitle, setMapTitle] = useState<string | null>(null)

	const currentRoute = useLocation()
	const getBackLink = () => {
		if (currentRoute.state) {
			if (backTitle === null) {
				setBackTitle(currentRoute.state.backButtonTitle)
				setBackLink(currentRoute.state.backButtonLink)
			}
			return { title: currentRoute.state.backButtonTitle, link: currentRoute.state.backButtonLink }
		}
		if (backTitle !== null) {
			return { title: backTitle, link: backLink }
		}
		return { title: 'Locations', link: routes.LOCATIONS }
	}

	const { entity: apiKey } = useSelector((state: any) => state.apiKey)

	const userLogin = useSelector((state: any) => state.userLogin)
	const { userInfo } = userLogin

	const { isLoading, isInitialized, location } = useSelector((state: any) => ({
		isLoading: state.locations.isLoading,
		isInitialized: state.locations.isInitialized,
		location: state.locations.entities[id],
	}))

	const { projectLoading, projectInitialized, project } = useSelector((state: any) => ({
		projectLoading: state.projects.isLoading,
		projectInitialized: state.projects.isInitialized,
		project: state.projects.entities[projectId],
	}))

	const { success: userListInitialized } = useSelector((state: any) => ({
		success: state.userList.isInitialized,
	}))

	useEffect(() => {
		if (!isInitialized) {
			dispatch(initializeActiveLocations())
		}
		dispatch(initializeProjects({ locationId: id }))
		if (!isInitialized) {
			dispatch(initializeUsers())
			dispatch(getLocationByID())
		}
		dispatch(initializeApiKey('REACT_APP_GOOGLE_API_KEY'))
	}, [dispatch, id, isInitialized, projectInitialized, userListInitialized])

	const openEdit = () => {
		setOpenEditPopup(true)
	}

	const handleEditLocation = async (values: any) => {
		const newLocation = await prepareLocationForSave(values)
		await dispatch(updateLocation(newLocation))
		await dispatch(initializeLocations())
	}

	const openInMap = () => {
		setCenter([location.latitude, location.longitude])
		setRecordForEdit(location)
		if (location.retailer) {
			setMapTitle(`${location.retailer} - ${location.assetName} - ${location.address}, ${location.city}, ${location.stateProvince}`)
		} else {
			setMapTitle(`${location.assetName} - ${location.address}, ${location.city}, ${location.stateProvince}`)
		}
		setOpenMap(true)
	}

	const partners = project?.partners
	const assetOwner = project?.owner
	const isMobile = useMediaQuery(_.MQ.before_nav)

	if (!location || isLoading) {
		return null
	}

	if (!project) {
		return null
	}

	let subRoutes: any[] = []
	if (location.assetType === 'center') {
		subRoutes = getCenterProjectRoutes(id, projectId)
	} else {
		if (assetOwner._id === userInfo._id) {
			subRoutes = getLocationProjectRoutes(id, projectId)
		} else {
			subRoutes = getLocationProjectPartnerRoutes(id, projectId)
		}
	}

	return (
		<div className="flex h-screen overflow-hidden bg-gray-50">
			<AdminPanelCN mobileOpen={mobileMenuOpen} onMobileClose={() => setMobileMenuOpen(false)} />

			<div className="flex-1 flex flex-col overflow-hidden">
				<HeaderCN onMobileMenuToggle={() => setMobileMenuOpen(!mobileMenuOpen)} />

				<div className="flex-shrink-0 border-b border-gray-200 bg-white px-6 py-2 flex items-center gap-3">
					<Avatar className="h-8 w-8">
						<AvatarImage src={location?.image} alt={location?.assetName} />
						<AvatarFallback className="text-xs bg-gray-200 text-gray-600">
							{(location?.assetName || '?').charAt(0).toUpperCase()}
						</AvatarFallback>
					</Avatar>
					{location?.owner?._id === userInfo?._id ? (
						<button
							type="button"
							onClick={openEdit}
							className="font-semibold text-sm text-[#0080fe] bg-transparent border-none p-0 m-0 cursor-pointer hover:underline"
						>
							{location?.assetName}
						</button>
					) : (
						<span className="font-semibold text-sm text-gray-800">{location?.assetName}</span>
					)}
					<button
						type="button"
						onClick={openInMap}
						className="text-sm text-[#0080fe] bg-transparent border-none p-0 m-0 cursor-pointer hover:underline"
					>
						{location?.address}, {location?.city}, {location?.stateProvince}
					</button>
					<span className="text-sm text-gray-500">Project Originator: {project?.owner?.name}</span>
					{/* Reports from a template, narrowed to this project (MYD-598). */}
					<AssetReportsButton type="project" entityId={projectId} name={project?.projectName} className="ml-auto" />
				</div>

				<SecondaryNavCN
					links={subRoutes}
					backLink={getBackLink()}
					sourceId={locationId}
					sourceName={location?.assetName}
				/>

				<div className="flex-1 flex overflow-hidden">
					<main className="flex-1 overflow-y-auto p-6">
						{isMobile && !isLoading && (
							<div style={{ marginBottom: '24px' }}>
								<BusinessCard
									isHorizontal
									image={location?.image}
									name={location?.assetName}
									address1={location?.address}
									address2={`${location?.city}, ${location?.stateProvince}`}
								/>
							</div>
						)}
						<RenderSubRoutes routes={subRoutes} state={currentRoute.state} />
					</main>

					<RightPanel storageKey="location-project" label="Project panel" className="overflow-hidden">
						{location && (
							<>
								<SidebarLocationProjectPartners
									location={location}
									project={project}
									assetOwner={assetOwner}
									assetName={location?.assetName}
									projectPartners={partners}
									userId={userInfo._id}
								/>
								<SidebarLocationProjectRecent project={project} />
							</>
						)}
					</RightPanel>
				</div>
			</div>

			<LocationActionSheet
				location={location}
				open={openEditPopup}
				onClose={() => setOpenEditPopup(false)}
				onEditLocation={handleEditLocation}
				showActions={false}
			/>
			{openMap && recordForEdit && (
				<MapLocationPopupCN
					open={openMap}
					onClose={() => setOpenMap(false)}
					apiKey={apiKey?.key}
					location={recordForEdit}
				/>
			)}
		</div>
	)
}

export default Locations_Projects_ShowCN
